import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Huseier from "./pages/Huseier";
import Pendler from "./pages/Pendler";
import Kontakt from "./pages/Kontakt";
import Personvern from "./pages/Personvern";
import Vilkar from "./pages/Vilkar";
import OmOss from "./pages/OmOss";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Survey from "./pages/Survey";
import { trackPageView } from "./lib/analytics";

function AnalyticsTracker() {
  const { pathname } = useLocation();
  React.useEffect(() => { trackPageView(pathname); }, [pathname]);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <main className="bg-ink text-cream min-h-screen pt-32 pb-20" data-testid="not-found">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <p className="text-amber text-sm font-bold tracking-widest uppercase">404</p>
        <h1 className="mt-4 font-display text-5xl md:text-7xl font-extrabold tracking-tighter" style={{ letterSpacing: "-0.04em" }}>
          Plassen er tom her.
        </h1>
        <p className="mt-6 text-cream/70 text-lg">Den siden finnes ikke — men oppkjørselen i Asker venter.</p>
        <a href="/" className="mt-10 inline-flex items-center gap-2 h-12 px-6 bg-amber text-ink font-display font-bold">Tilbake til Pendli →</a>
      </div>
    </main>
  );
}

function PublicShell({ children }) {
  return (
    <>
      <Navbar />
      <AnalyticsTracker />
      {children}
      <Footer />
    </>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  if (pathname.startsWith("/survey")) {
    return (
      <Routes>
        <Route path="/survey" element={<Survey />} />
      </Routes>
    );
  }

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    );
  }

  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pendler" element={<Pendler />} />
        <Route path="/huseier" element={<Huseier />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/om-oss" element={<OmOss />} />
        <Route path="/personvern" element={<Personvern />} />
        <Route path="/vilkar" element={<Vilkar />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PublicShell>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
